export const reps = (min: number, max: number) => {
  return min == max ? String(min) : String(min) + '-' + String(max)
}
